import { render } from "./FilterTypeDescription.vue?vue&type=template&id=8c81d4ae"
import script from "./FilterTypeDescription.vue?vue&type=script&lang=js"
export * from "./FilterTypeDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__